import { useCalendarDayNoteContext } from '../contexts/CalendarDayNoteContext';

export function useDayNotes() {
  const context = useCalendarDayNoteContext();
  
  if (!context) {
    throw new Error('useDayNotes must be used within a CalendarDayNoteProvider');
  }
  
  return context;
}

export default useDayNotes;